import { useTranslation } from "react-i18next";
import { ApiRoutes } from "../datasources/networking/apiRoutes";
import { GetOptionsContext, GetOptionsTopic } from "../datasources/requests/common";
import { Option, OptionsResponse } from "../datasources/responses/common";
import { useReadResource } from "./useResource";

/**
 * Hook for obtaining dynamic (server-side) options.
 */
export const useServerOptions = (topic: GetOptionsTopic, context?: GetOptionsContext) => {
	const { data, reload, isLoading, error } = useReadResource<undefined, OptionsResponse>({
		route: ApiRoutes.UtilsOptions,
		query: { topic, ...(context !== undefined && { context }) },
	});

	return {
		data,
		isLoading,
		reload,
		error,
	};
};

/**
 * Hook for obtaining static options.
 */
export const useStaticOptions = () => {
	const { t } = useTranslation();

	const languages: Array<Option> = [
		{ id: "en", label: t("preferences/language/en", { ns: "navigation" }) },
		{ id: "it", label: t("preferences/language/it", { ns: "navigation" }) },
		{ id: "es", label: t("preferences/language/es", { ns: "navigation" }) },
	];

	const userStatuses: Array<Option> = [
		{ id: 0, label: t("status_0", { ns: "feature.users" }) },
		{ id: 1, label: t("status_1", { ns: "feature.users" }) },
		{ id: 2, label: t("status_2", { ns: "feature.users" }) },
		{ id: 3, label: t("status_3", { ns: "feature.users" }) },
	];

	return { languages, userStatuses };
};
